import "./Menu.css";
import React from "react";
import { useNavigate } from "react-router-dom";
import VoiceBotIframe from "./VoiceBotiFrame";
function Menu() {
  const navigate = useNavigate();

  const navigateTo = (path) => {
    navigate(path);
  };

  return (
    <div className="MU-menu-container">
      <h1 className="MU-menu-header-title">The iSpeakWell Project</h1>
      <h5 className="MU-tagLine">
        Become a member of the iSpeakWell crew.
      </h5>
      <div className="MU-VoiceBot-container">
        <VoiceBotIframe />
      </div>
      <h5 className="MU-Task-Menu">What would you like to work on?</h5>
      <div className="MU-BTN-HLDR">
        <button className="primary-btn" onClick={() => navigateTo("/voicebot")}>The iSpeakWell Project</button>
        <button className="secondary-btn" onClick={() => navigateTo("/resumerevisor")}>Resume and Cover Letter</button>
        <button className="secondary-btn" onClick={() => navigateTo("/interview-practice")}>Interview Practice</button>
        <button className="secondary-btn" onClick={() => navigateTo("/conversationpractice")}>Conversation Practice</button>
        <button className="money-btn" onClick={() => navigateTo("/Purchase")}>Get Tokens</button>
      </div>
    </div>
  );
}
export default Menu;
